import firebase from 'firebase/app'
import 'firebase/storage'

export const ConfigDev = {
  token:
    'D8AKRbPiIl0yCwcENdmWOFAtMF44J0dc45cRITILjRkoCzrxxffw24EaKYHX5L0Nq3H83wh1FWSpiaSnLoDCS9WPuGQEWrdVT6iPAXn8syYGRIRvOAvRROEQnEzI97Jr7GR1zxGQTK5qh5bxSqU0S1IoNyXtzhHvhgCjwH6JeGtVT8HWyMs4KkpuOUd7ulWCtjTtqbFObsk5x7xo41ZAqYvlG2R21d43SzF9zfgjWSu9ntNCM5tVrnu8ZrNQLqRGMSe1byC0Xf4MyWDzq0Favr52FdvNEzj8jc5GgH82le8rqHmj8izpxSdG73xetedA',
  baseURL: 'https://asia-northeast1-sandee-dev.cloudfunctions.net/api',
  apiKey: 'AIzaSyB8KuqF9mhiavDLUQfUHQhp0sTzJLkxhH4',
  authDomain: 'sandee-dev.firebaseapp.com',
  databaseURL: 'https://sandee-dev.firebaseio.com',
  projectId: 'sandee-dev',
  storageBucket: 'sandee-dev.appspot.com',
  messagingSenderId: '423372672181',
  appId: '1:423372672181:web:5632ff52458ff237'
}

export const ConfigProd = {
  token:
    'D8AKRbPiIl0yCwcENdmWOFAtMF44J0dc45cRITILjRkoCzrxxffw24EaKYHX5L0Nq3H83wh1FWSpiaSnLoDCS9WPuGQEWrdVT6iPAXn8syYGRIRvOAvRROEQnEzI97Jr7GR1zxGQTK5qh5bxSqU0S1IoNyXtzhHvhgCjwH6JeGtVT8HWyMs4KkpuOUd7ulWCtjTtqbFObsk5x7xo41ZAqYvlG2R21d43SzF9zfgjWSu9ntNCM5tVrnu8ZrNQLqRGMSe1byC0Xf4MyWDzq0Favr52FdvNEzj8jc5GgH82le8rqHmj8izpxSdG73xetedA',

  baseURL: 'https://asia-northeast1-sandee-prod.cloudfunctions.net/api',
  apiKey: 'AIzaSyAoqWvrv5_AKj4Y22BZsDej_P2EFcHHLdQ',
  authDomain: 'sandee-prod.firebaseapp.com',
  databaseURL: 'https://sandee-prod.firebaseio.com',
  projectId: 'sandee-prod',
  storageBucket: 'sandee-prod.appspot.com',
  messagingSenderId: '655085350517',
  appId: '1:655085350517:web:396786ff3bd9ea9d'
}

export const fb = firebase.initializeApp(ConfigProd)
